module.exports = __webpack_public_path__ + "img/ring_g_l_1_0.f73c0a72.png";